module.exports = __webpack_public_path__ + "static/media/mobile_capy_page_area03_img_cn@2x.19581f40.png";